export class ListParams<T> {
    constructor(
        public filter = '',
        public search = '',
        public sortActive = '',
        public sortDirection = '',
        public pageNumber = 0,
        public pageSize = 20,
        public ordering?: string,
        public currentFilters?: T
    ) { }
}
